import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, Observable } from 'rxjs';
import { ComponentBase, OrderCustomerModel, ViewPriceListModel  } from 't4core';



@Component({
    selector: 'new-order-dialog',
    templateUrl: 'neworder.html',
})
export class NewOrderDialog extends ComponentBase {

    constructor(
        public dialogRef: MatDialogRef<NewOrderDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super();

      this.hidePricelist = (data && data.hidePricelist);
      this.requireExisting = (data && data.requireExisting);
      this.requireServiceLocation = (data && data.requireServiceLocation);

        this.txtCustomer.valueChanges.subscribe(x => {
            this.filteredCustomers = from(this.Api.get<OrderCustomerModel[]>("/TurboOrder/FilterCustomers", { searchText: x, limit: 50, servicePartner: this.requireServiceLocation ? this.requireServiceLocation : false }));
        });

        this.txtPricelist.valueChanges.subscribe(x => {
            this.filteredPricelists = from(this.Api.get<ViewPriceListModel[]>("/TurboOrder/FilterPricelists", { searchText: x, limit: 50 }));
        });
    }

    public hidePricelist: boolean = false;
  public requireExisting: boolean = false;
  public requireServiceLocation: boolean = false;

    public result = {
        selectedCustomer: new OrderCustomerModel(),
        selectedCustomerId: 0,
        selectedPricelistId: 0,
        orgNo: '',
        customerName: '',
        isValid: false
    };

    public loading: any = {
        validateOrgNo: false
    };

    public txtCustomer = new FormControl();
    public filteredCustomers: Observable<OrderCustomerModel[]>;

    public txtPricelist = new FormControl();
    public filteredPricelists: Observable<ViewPriceListModel[]>;

    public txtOrgNo = new FormControl('');


    public selectCustomer(customer: OrderCustomerModel) {
        this.result.selectedCustomer = customer;
        this.result.selectedCustomerId = customer.Id;
        this.result.customerName = '';
        this.txtOrgNo.setValue('');
        this.result.isValid = true;

        this.result.selectedPricelistId = 0;
        this.txtPricelist.setValue('');
    }

    public selectPricelist(pl: ViewPriceListModel) {
        this.result.selectedPricelistId = pl.Id;
        this.validateOrgNo();

        this.result.selectedCustomerId = 0;
        this.txtCustomer.setValue('');
    }

    public validateOrgNo() {
        this.result.selectedCustomerId = 0;
        this.txtCustomer.setValue('');

        this.txtOrgNo.setErrors({});
        this.txtOrgNo.updateValueAndValidity();
        this.result.isValid = false;
        
        if (this.txtOrgNo.value.length > 0) {
            this.loading.validateOrgNo = true;
            this.Api.get<string>("/TurboOrder/ValidateOrgNo", { orgNo: this.txtOrgNo.value }).then(x => {
                if (x) {
                    this.result.customerName = x;
                    this.result.isValid = this.hidePricelist || this.result.selectedPricelistId > 0;
                    this.result.orgNo = this.txtOrgNo.value;
                } else {
                    this.result.customerName = '';
                    this.txtOrgNo.setErrors({ "invalidNo": true });
                }   

                this.loading.validateOrgNo = false;
            });
        }
    }

    public close() {
        this.dialogRef.close(this.result);
    }
}
